
// ローディングインジケーター

import {Loading} from 'quasar'

let loadingCount = 0

function beginLoading() {
  if(++loadingCount === 1) {
    Loading.show({delay: 200})
  }
}

function endLoading() {
  if(--loadingCount === 0) {
    Loading.hide()
  }
}

// axiosインスタンス作成

import axios from 'axios'
import store from 'store'

let currentVersion = null

function createAxios() {
  const instance = axios.create()

  // CSRFトークン検証対応
  instance.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

  //
  instance.interceptors.request.use(
    config => {
      beginLoading()
      return config
    },
    error => Promise.reject(error)
  )

  instance.interceptors.response.use(
    response => {
      const version = response.headers['x-application-version'] || null
      store.commit('version', version)
      store.commit('maintenance', Boolean(response.headers['x-application-maintenance']))
      if(currentVersion == null) {
        currentVersion = version
      }
      else if(currentVersion != version) {
        currentVersion = version
        alert('アプリが更新されました。ブラウザのリロードが必要です')
        location.reload(true)
      }
      endLoading()
      return response
    },
    error => {
      endLoading()

      // エラー処理
      if(error.response) {
        if(error.response.status === 401 || error.response.status === 419) {
          console.log(error.response.status + ' 認証無効') // eslint-disable-line no-console
          store.dispatch('fetchConfig')
          return Promise.reject(new axios.Cancel())
        }
        if(error.response.status === 502 || error.response.status === 503) {
          console.log(error.response.status + ' メンテナンス中') // eslint-disable-line no-console
          store.commit('status', 'maintenance')
          store.commit('maintenanceMessage', error.response.data.message)
          store.commit('maintenanceRetryAfter', error.response.headers['retry-after'])
          return Promise.reject(new axios.Cancel())
        }
      }

      //
      return Promise.reject(error)
    }
  )

  //
  return instance
}

const instance = createAxios()
export {instance as axios}
